import backgroundLuckyWheelImage from '@/assets/images/backgroundLuckyWheel.jpg';
import backgroundLuckyWheelDeskImage from '@/assets/images/backgroundLuckyWheelDesk.jpg';
import LiderancaImage from '@/assets/images/logo-lideranca.png';
import { Colors } from '@/brands/msp/colors';
import { type WhitelabelConfig } from '@/brands/types';
import { LuckySequencyType } from '@/types/enums/HighlightedRaffle';

import type { Metadata } from 'next';

export const mspMetaData: Metadata = {
  title: 'Massa Prêmios',
  description: 'Plataforma de apostas',
  openGraph: {
    title: 'Massa Prêmios',
    description: 'Chance real de ganhar, na palma da sua mão!',
    siteName: 'Massa Prêmios',
    images: [
      {
        url: '/images/Logo-massapremios.png',
        width: 1200,
        height: 630,
        alt: 'Massa Prêmios',
      },
    ],
    locale: 'pt_BR',
    type: 'website',
  },
  icons: {
    icon: [{ url: '/favicon/Fav-massapremios.png', sizes: 'any' }],
    apple: '/favicon/Fav-massapremios.png',
  },
  robots: {
    index: true,
    follow: true,
    nocache: false,
  },
};

// TODO: add checkoutCheckboxes in WhitelabelConfig
export const mspConfig: WhitelabelConfig = {
  prizesFooterText:
    'São 4 prêmios finais, que somam o valor total de R$ 112.000,00, líquidos de Imposto de Renda (25%) e 200 prêmios instantâneos, que somam o valor total de R$ 10.000,00, líquidos de Imposto de Renda (30%).',
  labels: {
    aboutUs: 'Produto:',
    capitalizer: 'Sociedade de capitalização:',
    beneficiary: 'Instituição Beneficiada:',
  },
  name: 'msp',
  displayName: 'Massa Prêmios',
  availableGames: [LuckySequencyType.LUCKY_WHEEL],
  assets: {
    luckyWheelBackground: backgroundLuckyWheelImage.src,
    luckyWheelBackgroundDesktop: backgroundLuckyWheelDeskImage.src,
  },
  capitalizer: {
    logoFooter: LiderancaImage.src,
  },
  colors: Colors,
  meta: {
    favicon: '/favicon/Fav-massapremios.png',
    appleIcon: '/favicon/Fav-massapremios.png',
  },
  checkoutCheckboxes: {
    marketingOptIn: {
      visible: true,
      required: true,
      label: 'Aceito receber comunicações de marketing e ofertas',
      errorMessage: 'Você deve aceitar receber comunicações de marketing',
    },
    termsOfService: {
      visible: true,
      required: true,
      label: 'Concordo com os termos',
      errorMessage: 'Você deve concordar com os Termos de Uso',
      prefixText: 'Concordo com a',
      brandText: 'do Massa Prêmios',
      links: [
        { text: 'Política de Privacidade', href: '/politica-de-privacidade' },
        { text: 'Termos de Uso', href: '/termos-de-uso' },
      ],
    },
  },
};
